export default "__VITE_ASSET__ChEJur1z__"